module.exports = __webpack_public_path__ + "static/img/logo72.555cb87.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo72.png
// module id = r9Vt
// module chunks = 1